import { cn } from '@natu/utils/cn';
import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage';

type AvatarImage = {
  src?: string | null;
  alt?: string | null;
  title?: string | null;
};

interface AvatarGroupProps {
  className?: string;
  images?: AvatarImage[];
  withHover?: boolean;
}

const zIndexClasses = Array(20).map((_, index) => `z-[${index}]`);

const AvatarGroup = ({ className, images, withHover }: AvatarGroupProps) => {
  if (!isArrayWithLength(images)) {
    return null;
  }

  const imagesArr = images.filter(img => img?.src);

  return (
    <ul className={cn('flex', className)}>
      {imagesArr?.map((image, index) => (
        <li key={image.src}>
          <ResponsiveImage
            className={cn(
              'relative size-12 max-w-none rounded-full border-2 border-white md:size-20',
              withHover && 'md:transition-transform md:duration-200 md:hover:-translate-x-4',
              index && '-ml-3 md:-ml-6',
              zIndexClasses[index],
              className,
            )}
            width={80}
            height={80}
            src={image.src as string}
            alt={image.alt || image.title || 'Naturaily person'}
            sizes="80px"
          />
        </li>
      ))}
    </ul>
  );
};

export { AvatarGroup };
